<template>
  <div>
    <div class="loading">
      <div class="text">{{text}}<span class="dot">...</span></div>
    </div>
  </div>
</template>

<script>
export default {
  // props:['text'],
  name: 'Loading' ,// 定义的组件名称 使用时写法：loading,
  data(){
    return {
      text:'店播云智慧大脑正在分析中',
    }
  },
}
</script>

<style scoped>
.loading {
  position: absolute;
  left: 0;
  top: 0;
  background: url('/static/loading2.gif') center center no-repeat rgba(255,255,255,1);
  background-size: 100% 100%;
  width: 100%;
  /*height:100%;*/
  min-height: 70vh;
  z-index: 10000;
  border-radius: 8px;
}
.text{
  text-align: center;
  margin-top: 5%;
  color:#458cff;
  font-size: 30px;
  font-weight: bold;
}
.dot {
  font-family: simsun; /*固定字体避免设置的宽度无效*/
  animation: dot 2s infinite step-start;
  display: inline-block;
  width: 1.5em;
  vertical-align: bottom; /*始终让省略号在文字的下面*/
  overflow: hidden;
}
@keyframes dot { /*动态改变显示宽度, 但始终让总占据空间不变, 避免抖动*/
  0% { width: 0; margin-right: 1.5em; }
  33% { width: .5em; margin-right: 1em; }
  66% { width: 1em; margin-right: .5em; }
  100% { width: 1.5em; margin-right: 0;}
}
</style>
<style>
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .8s;
}
</style>



// WEBPACK FOOTER //
// src/components/template/loading.vue